import { connect } from 'react-redux'
import { mapProps, compose } from 'recompose'
import withYmme from 'components/common/hoc/withYmme'
import { updateVehicle } from '../../../actions'
import { VEHICLE_EDITOR_YMME } from '../../../constants'
import { processVehicleData } from '../../../helpers'
import YMMEEditor from './YMMEEditor'

const withYMMEPrefill = mapProps(({ userVehicleDetails, ...props }) => ({
  ...props,
  vehicle: processVehicleData(userVehicleDetails),
  userVehicleDetails
}))

const mapDispatchToProps = (dispatch, { ymmeTireSizesParams, onSubmit }) => ({
  handleSubmit: () => onSubmit()
    .then(() => dispatch(updateVehicle(ymmeTireSizesParams)))
})

export default compose(
  withYMMEPrefill,
  withYmme({ name: VEHICLE_EDITOR_YMME }),
  connect(null, mapDispatchToProps)
)(YMMEEditor)
